/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const exportInvoiceBody = zod.object({
  "invoiceId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const exportInvoicesBody = zod.object({
  "startDate": zod.string().datetime({}),
  "endDateExclusive": zod.string().datetime({}),
  "payeeUserId": zod.string().uuid().nullish(),
  "format": zod.enum(['Csv', 'Pdf'])
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getInvoiceExportByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getInvoiceExportByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const markInvoiceExportDownloadedParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const retryInvoiceExportParams = zod.object({
  "id": zod.string().uuid()
})

export const retryInvoiceExportResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const exportPayoutReportBody = zod.object({
  "dateBasis": zod.enum(['Paid', 'RequestCreated', 'Completed']),
  "startDate": zod.string().datetime({}),
  "endDate": zod.string().datetime({}),
  "sourceTypes": zod.array(zod.string()),
  "payeeType": zod.enum(['User', 'Organization']).optional(),
  "payeeId": zod.string().uuid().nullish(),
  "detail": zod.enum(['Lines', 'Deposits', 'Subtotals']),
  "format": zod.enum(['Csv', 'Pdf'])
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayoutReportExportByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayoutReportExportByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const markPayoutReportExportDownloadedParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const retryPayoutReportExportParams = zod.object({
  "id": zod.string().uuid()
})

export const retryPayoutReportExportResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const exportUnpaidCompletedWorkReportBody = zod.object({
  "fsmConnectionId": zod.string().uuid(),
  "dateBasis": zod.enum(['CompletionDate', 'RequestCreatedDate']),
  "startDate": zod.string().datetime({}),
  "endDate": zod.string().datetime({}),
  "payeeType": zod.enum(['User', 'Organization']).optional(),
  "payeeId": zod.string().uuid().nullish(),
  "techEmail": zod.string().nullish(),
  "statuses": zod.array(zod.enum(['NotPayable', 'NotReady', 'NotEvaluated', 'AwaitingSync', 'AwaitingTechMapping', 'SyncFailed', 'SyncAbandoned', 'AwaitingPayoutRequest', 'PayoutRequestPending', 'PayoutRequestReturned', 'PayoutRequestDenied', 'PayoutRequestApproved', 'PayoutScheduled', 'PaymentInProgress', 'PaymentFailed', 'PayoutVoided', 'Paid'])),
  "format": zod.enum(['Csv', 'Pdf'])
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getUnpaidCompletedWorkReportExportByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getUnpaidCompletedWorkReportExportByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const markUnpaidCompletedWorkReportExportDownloadedParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const retryUnpaidCompletedWorkReportExportParams = zod.object({
  "id": zod.string().uuid()
})

export const retryUnpaidCompletedWorkReportExportResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const exportCashflowReportBody = zod.object({
  "from": zod.string().date(),
  "to": zod.string().date(),
  "format": zod.enum(['Csv', 'Pdf'])
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getCashflowReportExportByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getCashflowReportExportByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const markCashflowReportExportDownloadedParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const retryCashflowReportExportParams = zod.object({
  "id": zod.string().uuid()
})

export const retryCashflowReportExportResponse = zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['Invoice', 'Earnings', 'Payout', 'UnpaidCompletedWork', 'Cashflow']),
  "status": zod.string(),
  "format": zod.enum(['Csv', 'Pdf']),
  "createdDate": zod.string().datetime({}),
  "fileReference": zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "url": zod.string(),
  "expiresAt": zod.string().datetime({})
}).optional()
})

